import { DATA_TOOL_LIMITS, normalizeText, validateTextSource } from "./data-tool-core.js";
import { parseJsonAst } from "./json-formatter-core.js";

export function buildJsonTree(source) {
  const text = normalizeText(source);
  const validation = validateTextSource(text, "JSON");
  if (validation) return { error: validation, tree: null };
  try {
    const value = parseJsonAst(text);
    let nodes = 0;
    let maxDepth = 0;
    const visit = (current, key = null, path = "$", depth = 0) => {
      nodes += 1;
      maxDepth = Math.max(maxDepth, depth);
      if (nodes > DATA_TOOL_LIMITS.nodes) throw new Error(`JSON exceeds the ${DATA_TOOL_LIMITS.nodes.toLocaleString("en-US")} node limit.`);
      if (depth > DATA_TOOL_LIMITS.depth) throw new Error(`JSON exceeds the ${DATA_TOOL_LIMITS.depth} level nesting limit.`);
      const type = nodeType(current);
      const children = type === "array"
        ? current.items.map((item, index) => visit(item, index, `${path}[${index}]`, depth + 1))
        : type === "object"
          ? current.entries.map(entry => visit(entry.value, entry.key.value, objectPath(path, entry.key.value), depth + 1))
          : [];
      return {
        key,
        path,
        type,
        value: type === "object" || type === "array" ? null : nodeValue(current, type),
        count: children.length,
        children
      };
    };
    return { error: "", tree: visit(value), nodes, maxDepth };
  } catch (error) {
    return { error: error?.message || "Invalid JSON.", tree: null };
  }
}

export function filterJsonTree(node, query) {
  const needle = String(query || "").trim().toLocaleLowerCase();
  if (!needle) return node;
  const children = node.children.map(child => filterJsonTree(child, needle)).filter(Boolean);
  const ownText = [node.key, node.path, node.type, node.value].filter(value => value != null).join(" ").toLocaleLowerCase();
  return ownText.includes(needle) || children.length ? { ...node, children } : null;
}

function escapePathKey(value) {
  return JSON.stringify(value);
}

function objectPath(parent, key) {
  return /^[A-Za-z_$][\w$]*$/.test(key) ? `${parent}.${key}` : `${parent}[${escapePathKey(key)}]`;
}

function nodeType(node) {
  if (node.type === "object" || node.type === "array") return node.type;
  if (node.type === "string") return "string";
  if (node.raw === "null") return "null";
  if (node.raw === "true" || node.raw === "false") return "boolean";
  return "number";
}

function nodeValue(node, type) {
  if (type === "string") return node.value;
  return node.raw;
}
